module.exports = __webpack_public_path__ + "img/success.5b60e5c3.png";